import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Member from '../../components/Member';
import WhyChooseUs from '../../components/WhyChooseUs';
import useTeamMembers from '../../hooks/useTeamMembers';
import Img from 'gatsby-image';
import { Helmet } from 'react-helmet';

const TheTeam = () => {
  const { team } = useTeamMembers();

  return (
    <div style={{ paddingTop: '4rem' }}>
      <Helmet>
        <title>The Team | Solaric</title>
      </Helmet>
      <Breadcrumb current='The Team' previous='about' />
      <div className='teamGrid'>
        <div className='row header-title text-center' id='completed'>
          <div className='col-md-8 col-lg-6 mx-auto' style={{ marginTop: '-3rem' }}>
            <h1>
              <span>management Team</span>
            </h1>
          </div>
        </div>
        {team.map(({ image, name, position, about, memberType }, i) => {
          if (memberType === 'management') {
            return (
              <div className='container teamMember' key={i}>
                <div className='image-wrapper'>{image && image.fluid && <Img fluid={image.fluid} alt='' />} </div>
                <div className='info'>
                  <h4>
                    {position}, {name}
                  </h4>
                  <div dangerouslySetInnerHTML={{ __html: about?.childMarkdownRemark?.html }}></div>
                </div>
              </div>
            );
          }
        })}
      </div>
      <div className='teamGrid bg-white' style={{ paddingBottom: '4rem' }}>
        <div className='row header-title text-center' id='completed'>
          <div className='col-md-8 col-lg-6 mx-auto' style={{ marginTop: '-3rem' }}>
            <h2>
              <span>Engineering Team</span>
            </h2>
          </div>
        </div>
        {team.map(({ image, name, position, about, memberType }, i) => {
          if (memberType === 'engineering') {
            return (
              <div className='container teamMember' key={i}>
                <div className='image-wrapper'>{image && image.fluid && <Img fluid={image.fluid} alt='' />} </div>
                <div className='info'>
                  <h4>
                    {position}, {name}
                  </h4>
                  <div dangerouslySetInnerHTML={{ __html: about?.childMarkdownRemark?.html }}></div>
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default TheTeam;
